import { Languages } from '../interfaces/common'

export const LOGON_PAGE_TITLE = {
  [Languages.RU]: 'Вход в продукты Актион',
  [Languages.KZ]: 'Вход в продукты «МЦФЭР-Казахстан»',
  [Languages.UZ]: {
    [Languages.RU]: 'Вход в продукты «МЦФЭР-Узбекистан»',
    [Languages.UZ]: '«MСFR-Oʼzbekiston» mahsulotlariga kirish',
  },
}

export const LOGON_PAGE_DESCRIPTION = {
  [Languages.RU]: 'Вход в Личный кабинет Актион-Медиа для зарегистрированного пользователя',
  [Languages.KZ]: 'Вход в Личный кабинет МЦФЭР-Казахстан для зарегистрированного пользователя',
  [Languages.UZ]: 'Вход в Личный кабинет ООО «Издательский дом МЦФЭР-У» для зарегистрированного пользователя',
}

export const LOGON_PAGE_KEYWORDS = {
  [Languages.RU]: 'вход, личный кабинет, Актион Медиа',
  [Languages.KZ]: 'вход, личный кабинет, МЦФЭР-Казахстан',
  [Languages.UZ]: 'вход, личный кабинет, ООО «Издательский дом МЦФЭР-У»',
}
